import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

const desktopStyles = {
  position: 'absolute',
  top: '24px',
  right: '24px',
  width: '182px',
};

const mobileStyles = {
  flex: '1 1 auto',
  width: '100%',
};

const ActionButton = withStyles(() => ({
  root: {
    color: '#FFF',
    backgroundColor: '#0CA58B',
    '&:hover': {
      backgroundColor: '#06947A',
    },
    height: '40px',
    borderRadius: '2px',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '16px',
    textTransform: 'uppercase',
    '@media (min-width:960px)': desktopStyles,
    '@media (max-width:959px)': mobileStyles,
  },
  disabled: {
    backgroundColor: 'rgba(12, 165, 139, 0.4)',
  },
}))(ButtonBase);

export default ActionButton;
